export const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: '2-digit',
    });
};

export const getNightDayDuration = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const diffTime = endDate - startDate;
    const totalDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 to include end date
    const nights = totalDays - 1;

    return `${nights} Night${nights > 1 ? 's' : ''} , ${totalDays} Day${totalDays > 1 ? 's' : ''}`;
};

export const formatDateMonthYear = (timestamp) => {
  if (!timestamp) return ""; // Handle invalid or empty timestamps

  const ts = String(timestamp).length === 10 ? timestamp * 1000 : timestamp;
  const date = new Date(ts);

  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
};
